module.exports = __webpack_public_path__ + "img/Sefara.7d97d168.png";